/**
 * Преобразует массив в объект, где каждый элемент становится ключом и значением
 * @param items Массив элементов, которые могут быть преобразованы в строку
 * @returns Объект с ключами и значениями из элементов массива
 */
export function arrayMirror<T extends string | number | symbol>(
    items: readonly T[]
): Record<string, T> {
    return Object.fromEntries(
        items.map(item => [item.toString(), item])
    ) as Record<string, T>;
}
